





import { Modal } from 'reactstrap';
import { Footer } from '../../../components/footer';
import { Link, useParams } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { useToast } from '../../../hook/usetoast';
import { useCreateTicket, useGetSingleTicket } from './api/api';
import { useProfileDetails } from '../../profile-details/api/profileapi';
import Loader from '../../Loader/buttonLoad';
import userprofileImage from '../../../assets/images/useruploadImg.png';

const TicketView = () => {
   const { id } = useParams();
   const toast = useToast();

   const [adminReply, setAdminReply] = useState('');
   const [selectedFiles, setSelectedFiles] = useState([]); // Array for multiple files
   const [activePreviewIdx, setActivePreviewIdx] = useState(0); // For the large preview
   const [loading, setLoading] = useState(false);
   const [modal, setModal] = useState(false);

   const toggle = () => {
      setModal(!modal);
      if (modal) setSelectedFiles([]); // Clear files if modal is closed
   };

   const chatContainerRef = useRef(null);
   const { data: getProfile } = useProfileDetails()
   const { data: getsupportlist, isLoading: SingleTicketLoading } = useGetSingleTicket({ ticketId: id });
   const updateMessagge = useCreateTicket();

   useEffect(() => {
      if (chatContainerRef.current) {
         chatContainerRef.current.scrollTo({
            top: chatContainerRef.current.scrollHeight,
            behavior: 'smooth',
         });
      }
   }, [getsupportlist?.data?.support]);

 
   const handleFileSelect = (e) => {
      const files = Array.from(e.target.files);
      const maxSize = 2 * 1024 * 1024; // 2MB
      const allowedTypes = ['image/png', 'image/jpeg']; // jpg & jpeg => image/jpeg
    
      const validFiles = files.filter((file) => {
        // 1) Type check
        if (!allowedTypes.includes(file.type)) {
          toast.error(
            `${file.name} is invalid image format. Only PNG, JPG, JPEG are allowed.`
          );
          return false;
        }
    
        // 2) Size check
        if (file.size > maxSize) {
          toast.error(`${file.name} is too large (Max 2MB)`);
          return false;
        }
    
        return true;
      });
    
      if (validFiles.length > 0) {
        // use functional update to avoid stale state
        setSelectedFiles((prev) => [...prev, ...validFiles]);
        setModal(true);
      }
    
      // allow re‑selecting the same file
      e.target.value = null;
    };
   const removeFile = (index) => {
      const updated = selectedFiles.filter((_, i) => i !== index);
      setSelectedFiles(updated);
      if (updated.length === 0) setModal(false);
      if (activePreviewIdx >= updated.length) setActivePreviewIdx(0);
   };

   const handleReplySubmit = async (e) => {
      e.preventDefault();
      if (!adminReply.trim() && selectedFiles.length === 0) return;

      setLoading(true);
      const formData = new FormData();
      formData.append('ticketId', id);
      formData.append('description', adminReply.trim());

      selectedFiles.forEach(file => {
         formData.append('image', file);
      });

      try {
         await updateMessagge.mutateAsync(formData);
         setAdminReply('');
         setSelectedFiles([]);
         setModal(false);
      } catch (error) {
         toast.error('Failed to send message');
      } finally {
         setLoading(false);
      }
   };

   const formatDate = (dateString) => {
      const date = new Date(dateString);
      const now = new Date();
      const diff = Math.floor((now - date) / 1000);
      if (diff < 60) return 'Just now';
      if (diff < 3600) return `${Math.floor(diff / 60)} mins ago`;
      if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
      return `${Math.floor(diff / 86400)} days ago`;
   };

   const ticket = getsupportlist?.data;
   const [previewModal, setPreviewModal] = useState(false);
   const [previewImageUrl, setPreviewImageUrl] = useState("");

   const togglePreview = () => setPreviewModal(!previewModal);

   const handleImageClick = (url) => {
      setPreviewImageUrl(url);
      setPreviewModal(true);
   };
   return (
      <>
         {(SingleTicketLoading || updateMessagge?.isLoading) && <Loader />}
         <div className="mainContent">
            <div className="pageContent def-py-30">
               <div className='container'>
                  <div className="appPagetitle d-flex g-10 align-items-center">
                     <Link to={'/support-ticket'} className='btn btnBack'>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                           <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                           <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                     </Link>
                     <span>View Ticket</span>
                  </div>

                  <div className='row'>
                     <div className="col-lg-12">
                        <div className="appcard pb-3 pt-4 cardbg">
                           <div className="vwTkDt">
                              <div className="vwTkDtCl">
                                 <div className="vwTkDtLb">ID</div>
                                 <div className="vwTkDtVl">#{ticket?.ticketId}</div>
                              </div>
                              <div className="vwTkDtCl">
                                 <div className="vwTkDtLb">Subject</div>
                                 <div className="vwTkDtVl">{ticket?.subject}</div>
                              </div>
                              <div className="vwTkDtCl">
                                 <div className="vwTkDtLb">Created</div>
                                 <div className="vwTkDtVl">{formatDate(ticket?.createdAt)}</div>
                              </div>
                              <div className="vwTkDtCl">
                                 <div className="vwTkDtLb">Last Activity</div>
                                 <div className="vwTkDtVl">{formatDate(ticket?.updatedAt)}</div>
                              </div>
                              <span className={ticket?.status === 'Open' ? 'text-lightyellow' : 'text-lightgreen'}>
                                 {ticket?.status}
                              </span>
                           </div>

                           <div className="vwTkChat">
                              <div className="vwTkChatBd" ref={chatContainerRef}>
                                 {ticket?.support?.map((msg, i) => (
                                    <div key={msg} className={`vwTkChatBx ${msg.sender === 'user' ? 'user' : 'admin'}`}>
                                       <div className="vwTkChatBxRw">
                                          <div className="vwTkChatPrf">
                                             <img
                                                src={msg.sender === 'user' ? getProfile?.profileImage || userprofileImage : require("../../../assets/images/coin45.png")}
                                                alt="avatar"
                                             />
                                          </div>
                                          <div className="vwTkChatMsDt">
                                             <div className="vwTkChatMs">

                                                {msg.image && (
                                                   <div className="mt-2 d-flex flex-wrap" style={{ gap: '10px' }}>
                                                      {Array.isArray(msg.image) ? (
                                                         // If it's an ARRAY (the JSON you just showed)
                                                         msg.image.map((imgUrl, idx) => (
                                                            <button
                                                               type="button"
                                                               key={imgUrl}
                                                               onClick={() => handleImageClick(imgUrl)}
                                                               style={{
                                                                  border: 'none',
                                                                  padding: 0,
                                                                  background: 'none',
                                                                  cursor: 'pointer',
                                                               }}
                                                            >
                                                               <img
                                                                  src={imgUrl}
                                                                  alt="attachment"
                                                                  style={{ maxWidth: '150px', borderRadius: '8px', cursor: 'pointer' }}
                                                               />
                                                            </button>
                                                         ))
                                                      ) : (
                                                         // If it's a STRING (single image)
                                                         <button
                                                            type="button"
                                                            onClick={() => handleImageClick(msg.image)}
                                                            style={{
                                                               border: 'none',
                                                               padding: 0,
                                                               background: 'none',
                                                               cursor: 'pointer',
                                                            }}
                                                         >
                                                            <img
                                                               src={msg.image}
                                                               alt="attachment"
                                                               style={{ maxWidth: '200px', borderRadius: '8px', display: 'block', cursor: 'pointer' }}
                                                            />
                                                         </button>
                                                      )}
                                                   </div>
                                                )}

                                                {msg.images && Array.isArray(msg.images) && (
                                                   <div className="mt-2 d-flex flex-wrap" style={{ gap: '10px' }}>
                                                      {msg.images.map((imgUrl, idx) => (
                                                         <img
                                                            key={imgUrl}
                                                            src={imgUrl}
                                                            alt="attachment"
                                                            style={{ maxWidth: '150px', borderRadius: '8px' }}
                                                         />
                                                      ))}
                                                   </div>
                                                )}

                                                {msg.comments && (
                                                   <div className={(msg.image || msg.images) ? "mt-2" : ""}>
                                                      {msg.comments}
                                                   </div>
                                                )}

                                             </div>
                                             <div className="vwTkChatDt">
                                                {msg.createdAt ? new Date(msg.createdAt).toLocaleString() : ""}
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 ))}
                              </div>

                              {ticket?.status !== 'closed' && (
                                 <div className="vwTkChatFt">
                                    <div className="input-group">
                                       <div className="chatFile">
                                          <input type="file" id="chat_file" multiple accept=".png,.jpg,.jpeg" onChange={handleFileSelect} />
                                          <label htmlFor="chat_file">
                                             Attachment
                                             <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="15" cy="15" r="15" fill="#181A20" />
                                                <path d="M20.436 14.8081V16.5721H15.732V20.8841H13.94V16.5721H9.208V14.8081H13.94V10.4961H15.732V14.8081H20.436Z" fill="#ffffff" />
                                             </svg>
                                          </label>
                                       </div>
                                       <textarea
                                          className='form-control'
                                          placeholder='Ask Me'
                                          rows={1}
                                          value={adminReply}
                                          onChange={(e) => setAdminReply(e.target.value)}
                                          onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) handleReplySubmit(e); }}
                                       ></textarea>
                                       <button className='btn btnChatSbm' onClick={handleReplySubmit} disabled={loading}>
                                          <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                             <path d="M7 1V15M7 1L13 7M7 1L1 7" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                          </svg>
                                       </button>
                                    </div>
                                 </div>
                              )}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <Footer />

         <Modal isOpen={modal} toggle={toggle} centered className="flAttMdlPt" backdropClassName='flAttMdlBkp' contentClassName='flAttMdl'>
            <div className="flAttMdlHd">
               <div className="flAttMdlLt">Share With #{ticket?.ticketId}</div>
               <div className="flAttMdlRt">
                  <button className='btn pr-0' onClick={toggle}>
                     <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.353516 0.353516L12.8535 12.8535M0.353516 12.8535L12.8535 0.353516" stroke="white" />
                     </svg>
                  </button>
               </div>
            </div>
            <div className="flAttMdlBd">
               <div className="flAttMdlBdLt">
                  <div className="fltAttMldPrv">
                     {selectedFiles[activePreviewIdx] && (
                        <img
                           src={URL.createObjectURL(selectedFiles[activePreviewIdx])}
                           alt="preview-large"
                           className='img-fluid'
                        />
                     )}
                  </div>
                  <div className="fltAttMldFrm">
                     <div className="fltAttMldIp">
                        <textarea
                           className='form-control'
                           placeholder='Your Comments'
                           rows={3}
                           value={adminReply}
                           onChange={(e) => setAdminReply(e.target.value)}
                        ></textarea>
                     </div>
                     <div className="fltAttMldSbm">
                        <button className='btn btn-secondary btnview' onClick={toggle}>Cancel</button>
                        <button className='btn btn-primary' onClick={handleReplySubmit} disabled={loading}>
                           {loading ? 'Sharing...' : 'Share'}
                        </button>
                     </div>
                  </div>
               </div>

               <div className="flAttMdlBdRt">
                  <div className="flAttMldLs">
                     {selectedFiles.map((file, index) => (
                        <button
                           key={file}
                           className={`flAttMldLsBx ${activePreviewIdx === index ? 'active' : ''}`}
                           onClick={() => setActivePreviewIdx(index)}
                           
                        >
                           <img src={URL.createObjectURL(file)} alt="thumb" className='img-fluid' />

                           <button className='btn close_file' onClick={(e) => { e.stopPropagation(); removeFile(index); }}>
                              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                 <circle cx="5" cy="5" r="5" fill="white" />
                                 <path d="M2.75 2.75L7.5 7.5" stroke="black" strokeWidth="0.5" />
                                 <path d="M2.75 7.5L7.5 2.75" stroke="black" strokeWidth="0.5" />
                              </svg>
                           </button>
                        </button>
                     ))}
                  </div>
               </div>
            </div>
         </Modal>
         <Modal
            isOpen={previewModal}
            toggle={togglePreview}
            centered
            size="lg"
            contentClassName="bg-transparent border-0"
         >
            <div className="position-relative text-center">
               <button
                  className="btn position-absolute"
                  onClick={togglePreview}
                  style={{ right: '-10px', top: '-40px', color: 'white', fontSize: '24px' }}
               >
                  <svg width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M0.353516 0.353516L12.8535 12.8535M0.353516 12.8535L12.8535 0.353516" stroke="white" strokeWidth="2" />
                  </svg>
               </button>
               <img
                  src={previewImageUrl}
                  alt="Preview"
                  className="img-fluid"
                  style={{ maxHeight: '80vh', borderRadius: '8px', boxShadow: '0 0 20px rgba(0,0,0,0.5)' }}
               />
            </div>
         </Modal>
      </>
   );
}

export default TicketView;



